import hcAxios, { RequestOptions } from 'core/utils/hcAxios'
import { TResponse } from 'core/service/hcResponse'
// hotcoin优化相关接口
enum API {
  /** 登录，首先不传验证码，如果调用失败加验证码继续调用此接口 @Felix */
  V3Login = '/hk-web/v3/login',
  /** 修改登录密码 @Felix */
  V3ModifyPwd = '/hk-web/v3/modifyPwd',
  /** 设置交易密码 @Felix */
  V3SetTradePwd = '/hk-web/v3/setTradePwd',
  /** 通过登录名获取手机邮箱信息，手机邮箱脱敏处理 @Felix */
  GetFuzzyInfo = '/hk-web/getFuzzyInfo',
  /** 重置交易密码 @Felix */
  V3ResetTradePwd = '/hk-web/v3/resetTradePwd',
  /** 重置登录密码 @admin */
  ResetLoginPwd = '/hk-web/resetLoginPwd',
  /** 重置登录密码检查第一步，检查帐号是否被注册 @admin */
  ResetLoginPwdCheck1 = '/hk-web/resetLoginPwdCheck1',
  /** 重置登录密码检查第二步，检查验证码是否正确 @admin */
  ResetLoginPwdCheck2 = '/hk-web/resetLoginPwdCheck2',
  /** 获取当前行为验证模型 @admin */
  V3GetBehaviorVerifyModel = '/hk-web/v3/getBehaviorVerifyModel',
  /** 验证极验/图形验证码 @admin */
  V3VerifyImage = '/hk-web/v3/verifyImage',
  /** 用户总资产 @admin */
  V3Balance = '/hk-web/v3/balance',
  /** 指纹、手势登录接口 @undefined */
  V3LoginGestureFingerprints = '/hk-web/v3/login/gestureFingerprints',
  /** 测试推送，后面删掉 @admin */
  Push = '/hk-web/push',
  /** 登录先验证极验/图形验证码，再验证账号密码 @undefined */
  V3VerifyImage4Login = '/hk-web/v3/verifyImage4Login',
  /** test @admin */
  Test = '/hk-web/test',
  /** 获取用户币币账户余额 @admin */
  V3CurrencyUserWalletTotal = '/hk-web/v3/currency/userWalletTotal',
  /** 重置登录密码检查第二步，检查验证码是否正确，添加极验等 @Peter */
  V2ResetLoginPwdCheck2 = '/hk-web/v2/resetLoginPwdCheck2',
  /** 安全项丢失申请 @Peter */
  V2SafetyItemApply = '/hk-web/v2/safetyItem/apply',
  /** 安全项丢失申请帐号检查，添加极验等 @Peter */
  V2SafetyItemApplyCheckAccount = '/hk-web/v2/safetyItem/apply/checkAccount',
  /** 指纹、手势登录接口(添加安全认证) @Peter */
  V4LoginGestureFingerprints = '/hk-web/v4/login/gestureFingerprints',
  /** 注册前校验第二步，添加极验等 @Peter */
  V4RegisterCheck2 = '/hk-web/v4/registerCheck2',
  /** 帮助中心查询正文详情 @Peter */
  CmsDetailCmsSupport = '/hk-web/cms/detailCmsSupport',
  /** 帮助中心搜索 @Peter */
  CmsSearchCms = '/hk-web/cms/searchCms',
  /** 帮助中心查询目录 @Peter */
  CmsSelectCalalog = '/hk-web/cms/selectCalalog',
  /** 帮助中心查询目录下列表 @Peter */
  CmsSelectCalalogList = '/hk-web/cms/selectCalalogList',
  /** 帮助中心查询最新文章 @Peter */
  CmsUpCmsSupport = '/hk-web/cms/upCmsSupport',
  /** 注册极光推送回调 @admin */
  Jcallback = '/hk-web/jcallback',
  /** 职业机会 @admin */
  Careers = '/hk-web/careers',
  /** 职位详情 @admin */
  CareersPosition = '/hk-web/careers/position',
  /** 初始化谷歌秘钥加密--后面删除 @admin */
  SecurityGoogleUrl = '/hk-web/security/googleUrl',
  /** 三项安全验证关闭前预检查 @Frank */
  CloseSafetyPrecheck = '/hk-web/closeSafetyPrecheck',
  /** 获取当前行为验证模型V4 @Frank */
  V4GetBehaviorVerifyModel = '/hk-web/v4/getBehaviorVerifyModel',
  /** 验证极验/图形验证码/Google验证 V4 @Frank */
  V4VerifyImage = '/hk-web/v4/verifyImage',
  /** 登录先验证极验/图形验证码，再验证账号密码 @Frank */
  V4VerifyImage4Login = '/hk-web/v4/verifyImage4Login',
  /** 用户总资产 @Frank */
  V4Balance = '/hk-web/v4/balance',
  /** 获取用户安全信息 @Frank */
  V2GetSecuritySetting = '/hk-web/v2/getSecuritySetting',
  /** 删除账号前置查询 @Frank */
  V1SecurityQueryAccount = '/hk-web/v1/security/query-account',
  /** 提交删除账号申请 @Frank */
  V1SecurityDeleteAccount = '/hk-web/v1/security/delete-account',
  /** 修改用户普通头像 @Frank */
  V2EditPhoto = '/hk-web/v2/editPhoto',
  /** 修改用户NFT头像 @Frank */
  V2EditNftPhoto = '/hk-web/v2/editNftPhoto',
  /** 检查用户是否可更新头像 @Frank */
  UserEditPhotoCheck = '/hk-web/user/editPhotoCheck',
  /** 用户总资产 @admin */
  V1AccountOverview = '/hk-web/v1/account/overview',
  /** 应用开屏页 @Frank */
  StartScreen = '/hk-web/start_screen',
  /** 发送验证码(email/sms) @Peter */
  SendValidCodeAddBlackList = '/hk-web/sendValidCode_addBlackList',
  /** 发送验证码(email/sms) @Peter */
  SendValidCodeGetBlackList = '/hk-web/sendValidCode_getBlackList',
  /** 发送验证码(email/sms)加密版本 @Frank */
  V1SendValidCode = '/hk-web/v1/sendValidCode',
  /** 获取当前行为验证模型V5 @Frank */
  V5GetBehaviorVerifyModel = '/hk-web/v5/getBehaviorVerifyModel',
  /** 获取最新可更新APP版本，没有则不返回(新版) @Frank */
  V1GetAppLatestVersion = '/hk-web/v1/getAppLatestVersion',
  /** 获取最新可更新APP版本，没有则不返回(新版) @Peter */
  TestV1GetAppLatestVersion = '/hk-web/test/v1/getAppLatestVersion',
  /** 检查账号是否存在 @Peter */
  V1AccountPrecheck = '/hk-web/v1/account/precheck',
  /** 注册前校验第一步，加密 @Peter */
  V4RegisterCheck1 = '/hk-web/v4/registerCheck1',
  /** 获取热门币种 @admin */
  PublicPopularCryptos = '/hk-web/public/popular_cryptos',
  /** 查询用户偏好设置 @Frank */
  UserGetPreferenceSetting = '/hk-web/user/get-preference-setting',
  /** 修改用户偏好设置 @Frank */
  UserModifyPreferenceSetting = '/hk-web/user/modify-preference-setting',
  /** 使用刷新令牌申请访问Token @Frank */
  UserApplyAccessToken = '/hk-web/user/apply-access-token',
  /** 用户退出登录 @Frank */
  UserLogout = '/hk-web/user/logout',
  /** 关闭用户弹窗 @admin */
  V1UserClosePopup = '/hk-web/v1/user/close-popup',
  /** 使用刷新令牌申请访问Token @Peter */
  TestUserApplyAccessToken = '/hk-web/test/user/apply-access-token',
  /** 用户总资产 @Frank */
  V2AccountOverview = '/hk-web/v2/account/overview',
  /** 登录，首先不传验证码，如果调用失败加验证码继续调用此接口 @Peter */
  TestLogin = '/hk-web/test/login',
  /** 接口解密 @admin */
  TestDecrypt = '/hk-web/test/decrypt',
  /** 邀请码检查，加密 @Peter */
  V1RegisterInviteCodeCheck = '/hk-web/v1/register/inviteCodeCheck',
  /** 非生产环境解密 @Peter */
  TestDecryptNL3IZf14IanfSlG1djJRvA98W8WrONBp = '/hk-web/test/decrypt/NL3IZf14IanfSlG1djJRvA98W8WrONBp',
  /** 获取平台介绍相关信息和分享者信息 @Frank */
  V1UserGetPlatformInfo = '/hk-web/v1/user/get-platform-info',
  /** 获取设备ID @ryan */
  GetDeviceId = '/hk-web/get/deviceId',
  /** getDeviceInfoTest @ryan */
  TestGetDeviceId = '/hk-web/test/get/deviceId',
  /** 获取用户现货账户列表 @brett */
  V1AccountSpot = '/hk-web/v1/account/spot',
  /** 查询登录设备 @Peter */
  V1UserGetLoginDevice = '/hk-web/v1/user/getLoginDevice',
  /** 移除登录设备 @Peter */
  V1UserRemoveLoginDevice = '/hk-web/v1/user/removeLoginDevice',
  /** 发送验证码(email/sms) @ryan */
  SendValidCodeAddBlackListLogin = '/hk-web/sendValidCode_addBlackListLogin',
  /** 发送验证码(email/sms) @ryan */
  SendValidCodeGetBlackListLogin = '/hk-web/sendValidCode_getBlackListLogin',
  /** 同步用户登录数据 @ryan */
  V1UserSyncLogUserDevice = '/hk-web/v1/user/syncLogUserDevice',
  /** 通过2项安全项重置第三项前置校验 @admin */
  ResetSafetyCheck = '/hk-web/resetSafetyCheck',
  /** 通过2项安全项重置第三项前置校验 @admin */
  ResetSafetyCheckTest = '/hk-web/resetSafetyCheckTest',
  /** 通过2项安全项重置第三项提交 @admin */
  ResetSafetySubmit = '/hk-web/resetSafetySubmit',
  /** 通过2项安全项重置第三项提交 @admin */
  ResetSafetySubmitTest = '/hk-web/resetSafetySubmitTest',
  /** 用户安全项丢失申请校验 @admin */
  UserSafetyItemApplyCheck = '/hk-web/user/safetyItem/apply/check',
  /** 用户安全项丢失申请状态 @admin */
  UserSafetyItemApplyStatus = '/hk-web/user/safetyItem/apply/status',
  /** 用户安全项丢失申请提交 @admin */
  UserSafetyItemApplySubmit = '/hk-web/user/safetyItem/apply/submit',
  /** 查询用户安全项 @brett */
  V2UserSecurity = '/hk-web/v2/userSecurity',
  /** 获取最新上币 @admin */
  CoinGetLatestCoin = '/hk-web/coin/getLatestCoin',
  /** 获取最新可更新APP版本，没有则不返回 @admin */
  CommonGetAppLatestVersion = '/hk-web/common/getAppLatestVersion',
  /** 获取公告列表 @admin */
  CommonListArticle = '/hk-web/common/listArticle',
  /** 获取轮播图、登录弹窗等 @admin */
  CommonListBanner = '/hk-web/common/listBanner',
  /** 安全项丢失申请 @admin */
  SafetyItemApply = '/hk-web/safetyItem/apply',
  /** 获取货币列表 @admin */
  CurrencyList = '/hk-web/currency/list',
  /** 保持登录时长 @admin */
  UserSetLoginTTL = '/hk-web/user/setLoginTTL',
  /** 获取主流交易对/推荐币对，走势图请调接口/kline/history @admin */
  CoinGetTradePair = '/hk-web/coin/getTradePair',
  /** 发送验证码(email/sms) @admin */
  SendValidCode = '/hk-web/sendValidCode',
  /**  获取谷歌key @admin */
  GetGoogleKey = '/hk-web/getGoogleKey',
  /** 安全项丢失申请帐号检查 @admin */
  SafetyItemApplyCheckAccount = '/hk-web/safetyItem/apply/checkAccount',
  /** 注册 @admin */
  V3Register = '/hk-web/v3/register',
  /** 验证新邮箱验证码 @admin */
  V2ValidateEmail = '/hk-web/v2/validate_email',
  /** 注册前校验第一步 @admin */
  V3RegisterCheck1 = '/hk-web/v3/registerCheck1',
  /** 注册前校验第二步 @admin */
  V3RegisterCheck2 = '/hk-web/v3/registerCheck2',
  /** 三项安全验证 @admin */
  ModifySafetyCheck = '/hk-web/modifySafetyCheck',
  /** 修改手机 @admin */
  ValidateNewPhone = '/hk-web/validate_new_phone',
  /** 修改邮箱 @admin */
  ValidateNewEmail = '/hk-web/validate_new_email',
  /** 绑定邮箱 @Felix */
  CommonBindEmail = '/hk-web/common/bind_email',
  /** 绑定谷歌 @Felix */
  CommonBindGoogle = '/hk-web/common/bind_google',
  /** 绑定手机 @Felix */
  CommonBindPhone = '/hk-web/common/bind_phone',
  /** 获取安全设置记录（最近10条） @Felix */
  UserGetSecurityLogs = '/hk-web/user/getSecurityLogs',
  /** 修改谷歌 @Felix */
  ValidateNewGoogleCode = '/hk-web/validate_new_google_code',
  /** 获取登录记录（最近10条） @admin */
  UserGetLoginLogs = '/hk-web/user/getLoginLogs',
}

export type TPostV3LoginParams = {
  /** 加密后的业务数据 */
  bizData?: string
  /** 随机向量 */
  randomIv?: string
  /** 随机密钥 */
  randomKey?: string
  /** 签名串 */
  signature?: string
  /** 时间戳 */
  timestamp?: number
}
export type TPostV3LoginResponse = TResponse<{
  contractToken?: string

  refreshToken?: string

  secretKey?: string

  token?: string

  userinfo?: any
}>
export const postV3Login = (params?: TPostV3LoginParams, options?: RequestOptions) => {
  return hcAxios.post<TPostV3LoginResponse>(API.V3Login, params, { options })
}

export type TPostV3ModifyPwdParams = {
  /** 加密后的业务数据 */
  bizData?: string
  /** 随机向量 */
  randomIv?: string
  /** 随机密钥 */
  randomKey?: string
  /** 签名串 */
  signature?: string
  /** 时间戳 */
  timestamp?: number
}
export type TPostV3ModifyPwdResponse = TResponse<any>
export const postV3ModifyPwd = (params?: TPostV3ModifyPwdParams, options?: RequestOptions) => {
  return hcAxios.post<TPostV3ModifyPwdResponse>(API.V3ModifyPwd, params, { options })
}

export type TPostV3SetTradePwdParams = {
  /** 加密后的业务数据 */
  bizData?: string
  /** 随机向量 */
  randomIv?: string
  /** 随机密钥 */
  randomKey?: string
  /** 签名串 */
  signature?: string
  /** 时间戳 */
  timestamp?: number
}
export type TPostV3SetTradePwdResponse = TResponse<any>
export const postV3SetTradePwd = (params?: TPostV3SetTradePwdParams, options?: RequestOptions) => {
  return hcAxios.post<TPostV3SetTradePwdResponse>(API.V3SetTradePwd, params, { options })
}

export type TGetGetFuzzyInfoParams = {
  /** loginName */
  loginName?: any
}
export type TGetGetFuzzyInfoResponse = TResponse<{
  /** 邮箱(脱敏) */
  email?: string
  /** 是否开启邮箱验证 */
  isOpenEmailValidate?: boolean
  /** 是否开启google验证 */
  isOpenGoogleValidate?: boolean
  /** 是否开启手机验证 */
  isOpenPhoneValidate?: boolean
  /** 手机(脱敏) */
  phone?: string
}>
export const getGetFuzzyInfo = (params?: TGetGetFuzzyInfoParams, options?: RequestOptions) => {
  return hcAxios.get<TGetGetFuzzyInfoResponse>(API.GetFuzzyInfo, { params, options })
}

export type TPostV3ResetTradePwdParams = {
  /** 加密后的业务数据 */
  bizData?: string
  /** 随机向量 */
  randomIv?: string
  /** 随机密钥 */
  randomKey?: string
  /** 签名串 */
  signature?: string
  /** 时间戳 */
  timestamp?: number
}
export type TPostV3ResetTradePwdResponse = TResponse<any>
export const postV3ResetTradePwd = (params?: TPostV3ResetTradePwdParams, options?: RequestOptions) => {
  return hcAxios.post<TPostV3ResetTradePwdResponse>(API.V3ResetTradePwd, params, { options })
}

export type TPostResetLoginPwdParams = {
  /** 加密后的业务数据 */
  bizData?: string
  /** 随机向量 */
  randomIv?: string
  /** 随机密钥 */
  randomKey?: string
  /** 签名串 */
  signature?: string
  /** 时间戳 */
  timestamp?: number
}
export type TPostResetLoginPwdResponse = TResponse<any>
export const postResetLoginPwd = (params?: TPostResetLoginPwdParams, options?: RequestOptions) => {
  return hcAxios.post<TPostResetLoginPwdResponse>(API.ResetLoginPwd, params, { options })
}

export type TPostResetLoginPwdCheck1Params = {
  /** 帐号是手机号码或者邮箱，手机号格式 86-15711941299 */
  account?: string
  /** 图形验证码 */
  imageCode?: string
  /** 校验类型 1-极验验证 2-图片验证 3-Google验证 */
  verifyType?: string
}
export type TPostResetLoginPwdCheck1Response = TResponse<any>
export const postResetLoginPwdCheck1 = (params?: TPostResetLoginPwdCheck1Params, options?: RequestOptions) => {
  return hcAxios.post<TPostResetLoginPwdCheck1Response>(API.ResetLoginPwdCheck1, params, { options })
}

export type TPostResetLoginPwdCheck2Params = {
  /** 加密后的业务数据 */
  bizData?: string
  /** 随机向量 */
  randomIv?: string
  /** 随机密钥 */
  randomKey?: string
  /** 签名串 */
  signature?: string
  /** 时间戳 */
  timestamp?: number
}
export type TPostResetLoginPwdCheck2Response = TResponse<any>
export const postResetLoginPwdCheck2 = (params?: TPostResetLoginPwdCheck2Params, options?: RequestOptions) => {
  return hcAxios.post<TPostResetLoginPwdCheck2Response>(API.ResetLoginPwdCheck2, params, { options })
}

export type TGetV3GetBehaviorVerifyModelParams = {}
export type TGetV3GetBehaviorVerifyModelResponse = TResponse<{
  /** 行为验证类型: 1-极验验证, 2-图片验证, 3-Google验证 */
  behaviorVerifyType?: string

  geeTest?: {
    captchaId?: string

    challenge?: string

    gt?: string

    new_captcha?: boolean

    success?: number
  }
  /** reCaptcha网站密钥 */
  grSiteKey?: string

  kaptchaImage?: {
    image?: string

    imgToken?: string
  }
}>
export const getV3GetBehaviorVerifyModel = (params?: TGetV3GetBehaviorVerifyModelParams, options?: RequestOptions) => {
  return hcAxios.get<TGetV3GetBehaviorVerifyModelResponse>(API.V3GetBehaviorVerifyModel, { params, options })
}

export type TPostV3VerifyImageParams = {
  /** GT v4验证输出信息 */
  captchaOutput?: string
  /** GT v4验证通过时间戳 */
  genTime?: string
  /** 极验参数 */
  gtChallenge?: string
  /** 极验参数 */
  gtSeccode?: string
  /** 极验参数 */
  gtValidate?: string
  /** 图片imageToken */
  imageToken?: string
  /** GT v4验证流水号 */
  lotNumber?: string
  /** GT v4验证通过标识 */
  passToken?: string
  /** GT v4验证场景id */
  sceneId?: number
  /** 图片数字 */
  validCode?: string
  /** 校验类型 1-极验验证 2-图片验证 3-Google验证 */
  verifyType?: string
}
export type TPostV3VerifyImageResponse = TResponse<{
  /** 验证结果： 1-成功， 2-失败 */
  status?: number
  /** 极验版本号 */
  version?: string
}>
export const postV3VerifyImage = (params?: TPostV3VerifyImageParams, options?: RequestOptions) => {
  return hcAxios.post<TPostV3VerifyImageResponse>(API.V3VerifyImage, params, { options })
}

export type TGetV3BalanceParams = any
export type TGetV3BalanceResponse = TResponse<{
  /** 总资产折合成人民币 */
  totalCny?: string
}>
export const getV3Balance = (params?: TGetV3BalanceParams, options?: RequestOptions) => {
  return hcAxios.get<TGetV3BalanceResponse>(API.V3Balance, { params, options })
}

export type TPostV3LoginGestureFingerprintsParams = {
  /** 加密后的业务数据 */
  bizData?: string
  /** 随机向量 */
  randomIv?: string
  /** 随机密钥 */
  randomKey?: string
  /** 签名串 */
  signature?: string
  /** 时间戳 */
  timestamp?: number
}
export type TPostV3LoginGestureFingerprintsResponse = TResponse<{
  contractToken?: string

  refreshToken?: string

  secretKey?: string

  token?: string

  userinfo?: any
}>
export const postV3LoginGestureFingerprints = (
  params?: TPostV3LoginGestureFingerprintsParams,
  options?: RequestOptions
) => {
  return hcAxios.post<TPostV3LoginGestureFingerprintsResponse>(API.V3LoginGestureFingerprints, params, { options })
}

export type TGetPushParams = {
  /** uid */
  uid?: any
  /** msg */
  msg?: any
}
export type TGetPushResponse = TResponse<any>
export const getPush = (params?: TGetPushParams, options?: RequestOptions) => {
  return hcAxios.get<TGetPushResponse>(API.Push, { params, options })
}

export type TPostV3VerifyImage4LoginParams = {
  /** 加密后的业务数据 */
  bizData?: string
  /** 随机向量 */
  randomIv?: string
  /** 随机密钥 */
  randomKey?: string
  /** 签名串 */
  signature?: string
  /** 时间戳 */
  timestamp?: number
}
export type TPostV3VerifyImage4LoginResponse = TResponse<{
  /** 验证结果： 1-成功， 2-失败 */
  status?: number
  /** 极验版本号 */
  version?: string
}>
export const postV3VerifyImage4Login = (params?: TPostV3VerifyImage4LoginParams, options?: RequestOptions) => {
  return hcAxios.post<TPostV3VerifyImage4LoginResponse>(API.V3VerifyImage4Login, params, { options })
}

export type TGetTestParams = any
export type TGetTestResponse = TResponse<any>
export const getTest = (params?: TGetTestParams, options?: RequestOptions) => {
  return hcAxios.get<TGetTestResponse>(API.Test, { params, options })
}

export type TGetV3CurrencyUserWalletTotalParams = {
  /** coinName */
  coinName?: any
}
export type TGetV3CurrencyUserWalletTotalResponse = TResponse<{
  /** 币币余额 */
  total?: number

  totalStr?: string
}>
export const getV3CurrencyUserWalletTotal = (
  params?: TGetV3CurrencyUserWalletTotalParams,
  options?: RequestOptions
) => {
  return hcAxios.get<TGetV3CurrencyUserWalletTotalResponse>(API.V3CurrencyUserWalletTotal, { params, options })
}

export type TPostV2ResetLoginPwdCheck2Params = {
  /** 加密后的业务数据 */
  bizData?: string
  /** 随机向量 */
  randomIv?: string
  /** 随机密钥 */
  randomKey?: string
  /** 签名串 */
  signature?: string
  /** 时间戳 */
  timestamp?: number
}
export type TPostV2ResetLoginPwdCheck2Response = TResponse<any>
export const postV2ResetLoginPwdCheck2 = (params?: TPostV2ResetLoginPwdCheck2Params, options?: RequestOptions) => {
  return hcAxios.post<TPostV2ResetLoginPwdCheck2Response>(API.V2ResetLoginPwdCheck2, params, { options })
}

export type TPostV2SafetyItemApplyParams = {
  /** 加密后的业务数据 */
  bizData?: string
  /** 随机向量 */
  randomIv?: string
  /** 随机密钥 */
  randomKey?: string
  /** 签名串 */
  signature?: string
  /** 时间戳 */
  timestamp?: number
}
export type TPostV2SafetyItemApplyResponse = TResponse<any>
export const postV2SafetyItemApply = (params?: TPostV2SafetyItemApplyParams, options?: RequestOptions) => {
  return hcAxios.post<TPostV2SafetyItemApplyResponse>(API.V2SafetyItemApply, params, { options })
}

export type TGetV2SafetyItemApplyCheckAccountParams = {
  /** 账号是手机号码或者邮箱，手机号格式 86-15711941299 */
  account?: any
  /** 极验或图片验证码 */
  imageCode?: any
  /** 校验类型 1-极验验证 2-图片验证 3-Google验证 */
  verifyType?: any
}
export type TGetV2SafetyItemApplyCheckAccountResponse = TResponse<any>
export const getV2SafetyItemApplyCheckAccount = (
  params?: TGetV2SafetyItemApplyCheckAccountParams,
  options?: RequestOptions
) => {
  return hcAxios.get<TGetV2SafetyItemApplyCheckAccountResponse>(API.V2SafetyItemApplyCheckAccount, { params, options })
}

export type TPostV4LoginGestureFingerprintsParams = {
  /** 加密后的业务数据 */
  bizData?: string
  /** 随机向量 */
  randomIv?: string
  /** 随机密钥 */
  randomKey?: string
  /** 签名串 */
  signature?: string
  /** 时间戳 */
  timestamp?: number
}
export type TPostV4LoginGestureFingerprintsResponse = TResponse<{
  contractToken?: string

  refreshToken?: string

  secretKey?: string

  token?: string

  userinfo?: any
}>
export const postV4LoginGestureFingerprints = (
  params?: TPostV4LoginGestureFingerprintsParams,
  options?: RequestOptions
) => {
  return hcAxios.post<TPostV4LoginGestureFingerprintsResponse>(API.V4LoginGestureFingerprints, params, { options })
}

export type TPostV4RegisterCheck2Params = {
  /** 加密后的业务数据 */
  bizData?: string
  /** 随机向量 */
  randomIv?: string
  /** 随机密钥 */
  randomKey?: string
  /** 签名串 */
  signature?: string
  /** 时间戳 */
  timestamp?: number
}
export type TPostV4RegisterCheck2Response = TResponse<any>
export const postV4RegisterCheck2 = (params?: TPostV4RegisterCheck2Params, options?: RequestOptions) => {
  return hcAxios.post<TPostV4RegisterCheck2Response>(API.V4RegisterCheck2, params, { options })
}

export type TGetCmsDetailCmsSupportParams = {
  /** 正文id */
  id?: any
}
export type TGetCmsDetailCmsSupportResponse = TResponse<{
  /** 路径 */
  catalogPath?: string
  /** 内容 */
  content?: string
  /** 创建时间 */
  createdTime?: number
  /** id */
  id?: string
  /** 语言 */
  lang?: string
  /** 标题 */
  title?: string
  /** 累计访问量 */
  visitCnt?: number
}>
export const getCmsDetailCmsSupport = (params?: TGetCmsDetailCmsSupportParams, options?: RequestOptions) => {
  return hcAxios.get<TGetCmsDetailCmsSupportResponse>(API.CmsDetailCmsSupport, { params, options })
}

export type TGetCmsSearchCmsParams = {
  /** 页码 */
  pageNum?: any
  /** 每页显示条数 */
  pageSize?: any
  /** 是否返回总记录数，默认true */
  count?: any
  /** 搜索关键字 */
  keywords?: any
  /** 语言，比如zh_CN */
  lang?: any
}
export type TGetCmsSearchCmsResponse = TResponse<
  {
    /** 路径 */
    catalogPath?: string
    /** 内容 */
    content?: string
    /** 创建人 */
    createdBy?: string
    /** 创建时间 */
    createdTime?: number
    /** id */
    id?: string
    /** 语言 */
    lang?: string
    /** 类型 目录-catalog 正文-text */
    status?: string
    /** 标题 */
    title?: string
  }[]
>
export const getCmsSearchCms = (params?: TGetCmsSearchCmsParams, options?: RequestOptions) => {
  return hcAxios.get<TGetCmsSearchCmsResponse>(API.CmsSearchCms, { params, options })
}

export type TGetCmsSelectCalalogParams = {
  /** code 如果查一级目录不用传 默认是0 */
  code?: any
  /** 语言，比如zh_CN */
  lang?: any
}
export type TGetCmsSelectCalalogResponse = TResponse<
  {
    /** 类别编码 */
    catalogCode?: string
    /** id */
    id?: string
    /** 语言 */
    lang?: string
    /** 父级id */
    parentCode?: string
    /** 类别标题 */
    title?: string
  }[]
>
export const getCmsSelectCalalog = (params?: TGetCmsSelectCalalogParams, options?: RequestOptions) => {
  return hcAxios.get<TGetCmsSelectCalalogResponse>(API.CmsSelectCalalog, { params, options })
}

export type TGetCmsSelectCalalogListParams = {
  /** 目录id */
  id?: any
}
export type TGetCmsSelectCalalogListResponse = TResponse<
  {
    /** 下级列表 */
    catalogVOList?: {}[]
    /** 类别编码 */
    code?: string
    /** id */
    id?: string
    /** 语言 */
    lang?: string
    /** 父级id */
    parentCode?: string
    /** 类别标题 */
    title?: string
  }[]
>
export const getCmsSelectCalalogList = (params?: TGetCmsSelectCalalogListParams, options?: RequestOptions) => {
  return hcAxios.get<TGetCmsSelectCalalogListResponse>(API.CmsSelectCalalogList, { params, options })
}

export type TGetCmsUpCmsSupportParams = {
  /** 语言，比如zh_CN */
  lang?: any
}
export type TGetCmsUpCmsSupportResponse = TResponse<
  {
    /** 创建时间 */
    createdTime?: number
    /** id */
    id?: string
    /** 标题 */
    title?: string
  }[]
>
export const getCmsUpCmsSupport = (params?: TGetCmsUpCmsSupportParams, options?: RequestOptions) => {
  return hcAxios.get<TGetCmsUpCmsSupportResponse>(API.CmsUpCmsSupport, { params, options })
}

export type TPostJcallbackParams = {
  /** 加密后的业务数据 */
  bizData?: string
  /** 随机向量 */
  randomIv?: string
  /** 随机密钥 */
  randomKey?: string
  /** 签名串 */
  signature?: string
  /** 时间戳 */
  timestamp?: number
}
export type TPostJcallbackResponse = TResponse<any>
export const postJcallback = (params?: TPostJcallbackParams, options?: RequestOptions) => {
  return hcAxios.post<TPostJcallbackResponse>(API.Jcallback, params, { options })
}

export type TGetCareersParams = any
export type TGetCareersResponse = TResponse<{
  /** 联系方式 */
  contactList?: string[]
  /** 职位列表 */
  positionList?: {
    /** id */
    id?: number
    /** 职位编码 */
    positionCode?: string
    /** 岗位图标 */
    positionIcon?: string
    /** 岗位名称 */
    positionName?: string
    /** 岗位要求 */
    requirements?: string
    /** 工作职责 */
    responsibilities?: string
    /** 工作地点 */
    workPlaces?: string
  }[]
}>
export const getCareers = (params?: TGetCareersParams, options?: RequestOptions) => {
  return hcAxios.get<TGetCareersResponse>(API.Careers, { params, options })
}

export type TGetCareersPositionParams = {
  /** positionCode */
  positionCode?: any
}
export type TGetCareersPositionResponse = TResponse<{
  /** 联系方式 */
  contactList?: string[]
  /** 职业机会-职位信息 */
  position?: {
    /** id */
    id?: number
    /** 职位编码 */
    positionCode?: string
    /** 岗位图标 */
    positionIcon?: string
    /** 岗位名称 */
    positionName?: string
    /** 岗位要求 */
    requirements?: string
    /** 工作职责 */
    responsibilities?: string
    /** 工作地点 */
    workPlaces?: string
  }
}>
export const getCareersPosition = (params?: TGetCareersPositionParams, options?: RequestOptions) => {
  return hcAxios.get<TGetCareersPositionResponse>(API.CareersPosition, { params, options })
}

export type TGetSecurityGoogleUrlParams = any
export type TGetSecurityGoogleUrlResponse = TResponse<any>
export const getSecurityGoogleUrl = (params?: TGetSecurityGoogleUrlParams, options?: RequestOptions) => {
  return hcAxios.get<TGetSecurityGoogleUrlResponse>(API.SecurityGoogleUrl, { params, options })
}

export type TPostCloseSafetyPrecheckParams = {
  /** 加密后的业务数据 */
  bizData?: string
  /** 随机向量 */
  randomIv?: string
  /** 随机密钥 */
  randomKey?: string
  /** 签名串 */
  signature?: string
  /** 时间戳 */
  timestamp?: number
}
export type TPostCloseSafetyPrecheckResponse = TResponse<any>
export const postCloseSafetyPrecheck = (params?: TPostCloseSafetyPrecheckParams, options?: RequestOptions) => {
  return hcAxios.post<TPostCloseSafetyPrecheckResponse>(API.CloseSafetyPrecheck, params, { options })
}

export type TGetV4GetBehaviorVerifyModelParams = {}
export type TGetV4GetBehaviorVerifyModelResponse = TResponse<{
  /** 行为验证类型: 1-极验验证, 2-图片验证, 3-Google验证 */
  behaviorVerifyType?: string

  geeTest?: {
    captchaId?: string

    challenge?: string

    gt?: string

    new_captcha?: boolean

    success?: number
  }
  /** reCaptcha网站密钥 */
  grSiteKey?: string

  kaptchaImage?: {
    image?: string

    imgToken?: string
  }
}>
export const getV4GetBehaviorVerifyModel = (params?: TGetV4GetBehaviorVerifyModelParams, options?: RequestOptions) => {
  return hcAxios.get<TGetV4GetBehaviorVerifyModelResponse>(API.V4GetBehaviorVerifyModel, { params, options })
}

export type TPostV4VerifyImageParams = {
  /** 加密后的业务数据 */
  bizData?: string
  /** 随机向量 */
  randomIv?: string
  /** 随机密钥 */
  randomKey?: string
  /** 签名串 */
  signature?: string
  /** 时间戳 */
  timestamp?: number
}
export type TPostV4VerifyImageResponse = TResponse<{
  /** 验证结果： 1-成功， 2-失败 */
  status?: number
  /** 极验版本号 */
  version?: string
}>
export const postV4VerifyImage = (params?: TPostV4VerifyImageParams, options?: RequestOptions) => {
  return hcAxios.post<TPostV4VerifyImageResponse>(API.V4VerifyImage, params, { options })
}

export type TPostV4VerifyImage4LoginParams = {
  /** 加密后的业务数据 */
  bizData?: string
  /** 随机向量 */
  randomIv?: string
  /** 随机密钥 */
  randomKey?: string
  /** 签名串 */
  signature?: string
  /** 时间戳 */
  timestamp?: number
}
export type TPostV4VerifyImage4LoginResponse = TResponse<{
  /** 验证结果： 1-成功， 2-失败 */
  status?: number
  /** 极验版本号 */
  version?: string
}>
export const postV4VerifyImage4Login = (params?: TPostV4VerifyImage4LoginParams, options?: RequestOptions) => {
  return hcAxios.post<TPostV4VerifyImage4LoginResponse>(API.V4VerifyImage4Login, params, { options })
}

export type TGetV4BalanceParams = any
export type TGetV4BalanceResponse = TResponse<{
  /** 资产详情 */
  assets?: {
    /** 资产折合成BTC */
    assetBtc?: string
    /** 资产折合成人民币 */
    assetCny?: string
    /** 资产折合成ETH */
    assetEth?: string
    /** 资产类型，1现货、2杠杆全仓、3杠杆逐仓、4永续合约、5C2C、6理财、7合约跟单 8交割合约 */
    assetType?: number
    /** 资产折合成USDT */
    assetUsdt?: string
    /** 资产占比 */
    proportion?: number
  }[]
  /** BTC24小时涨跌幅 */
  changeBtc?: string
  /** 人民币24小时涨跌幅 */
  changeCny?: string
  /** ETH24小时涨跌幅 */
  changeEth?: string
  /** 24小时涨跌幅率，例子12.01表示12.01% */
  changeRate?: string
  /** USDT24小时涨跌幅 */
  changeUsdt?: string
  /** 持仓币种列表 */
  holdings?: {
    /** 资产数量 */
    amount?: string
    /** 资产数量折合CNY */
    amountCny?: number
    /** 24小时涨跌幅 */
    change?: string
    /** 资产ID */
    coinId?: number
    /** 资产名称 */
    coinName?: string
    /** 持仓币种比例，比如99.99%返回99.99 */
    distributionRate?: string
    /** 显示类型 1-持仓 2-热门 */
    showType?: number
    /** 有效交易对ID */
    tradeId?: number
    /** 资产LOGO */
    webLogo?: string
  }[]
  /** 推荐币种列表 */
  recommends?: {
    /** 资产数量 */
    amount?: string
    /** 资产数量折合CNY */
    amountCny?: number
    /** 24小时涨跌幅 */
    change?: string
    /** 资产ID */
    coinId?: number
    /** 资产名称 */
    coinName?: string
    /** 持仓币种比例，比如99.99%返回99.99 */
    distributionRate?: string
    /** 显示类型 1-持仓 2-热门 */
    showType?: number
    /** 有效交易对ID */
    tradeId?: number
    /** 资产LOGO */
    webLogo?: string
  }[]
  /** 总资产折合成BTC */
  totalBtc?: string
  /** 总资产折合成人民币 */
  totalCny?: string
  /** 总资产折合成ETH */
  totalEth?: string
  /** 总资产折合成USDT */
  totalUsdt?: string
}>
export const getV4Balance = (params?: TGetV4BalanceParams, options?: RequestOptions) => {
  return hcAxios.get<TGetV4BalanceResponse>(API.V4Balance, { params, options })
}

export type TGetV2GetSecuritySettingParams = {
  /** 登录名 */
  loginName?: any
}
export type TGetV2GetSecuritySettingResponse = TResponse<{
  data?: {
    /** 是否开启邮箱验证 */
    isOpenEmailValidate?: boolean
    /** 是否开启谷歌验证 */
    isOpenGoogleValidate?: boolean
    /** 是否开启手机验证 */
    isOpenPhoneValidate?: boolean
    /** 是否已实名认证 */
    isUserIdentityAuth?: boolean
    /** 是否设置交易密码 */
    isUserTradePasswordSet?: boolean
    /** 是否满足至少开启两种安全方式 */
    isSecurityValidateDone?: boolean
    /** 电子邮件地址 */
    email?: string
    /** 手机号码 */
    phone?: string
  }
}>
export const getV2GetSecuritySetting = (params?: TGetV2GetSecuritySettingParams, options?: RequestOptions) => {
  return hcAxios.get<TGetV2GetSecuritySettingResponse>(API.V2GetSecuritySetting, { params, options })
}

export type TGetV1SecurityQueryAccountParams = {
  /** 加密后的业务数据 */
  bizData?: string
  /** 随机向量 */
  randomIv?: string
  /** 随机密钥 */
  randomKey?: string
  /** 签名串 */
  signature?: string

  targetObj?: any
  /** 时间戳 */
  timestamp?: number
}
export type TGetV1SecurityQueryAccountResponse = TResponse<{
  /** 登录账号 */
  account?: string
  /** NFT资产数量 */
  nftQuantity?: number
  /** 总资产(BTC) */
  totalBalanceInBtc?: string
  /** 总资产(USDT) */
  totalBalanceInUsdt?: string
  /** 用户UID */
  userId?: number
}>
export const getV1SecurityQueryAccount = (params?: TGetV1SecurityQueryAccountParams, options?: RequestOptions) => {
  return hcAxios.get<TGetV1SecurityQueryAccountResponse>(API.V1SecurityQueryAccount, { params, options })
}

export type TPostV1SecurityDeleteAccountParams = {
  /** 加密后的业务数据 */
  bizData?: string
  /** 随机向量 */
  randomIv?: string
  /** 随机密钥 */
  randomKey?: string
  /** 签名串 */
  signature?: string
  /** 时间戳 */
  timestamp?: number
}
export type TPostV1SecurityDeleteAccountResponse = TResponse<boolean>
export const postV1SecurityDeleteAccount = (params?: TPostV1SecurityDeleteAccountParams, options?: RequestOptions) => {
  return hcAxios.post<TPostV1SecurityDeleteAccountResponse>(API.V1SecurityDeleteAccount, params, { options })
}

export type TPostV2EditPhotoParams = any
export type TPostV2EditPhotoResponse = TResponse<{}>
export const postV2EditPhoto = (params?: TPostV2EditPhotoParams, options?: RequestOptions) => {
  return hcAxios.post<TPostV2EditPhotoResponse>(API.V2EditPhoto, params, { options })
}

export type TPostV2EditNftPhotoParams = {
  /** NFT资产id */
  assetId?: number
}
export type TPostV2EditNftPhotoResponse = TResponse<{}>
export const postV2EditNftPhoto = (params?: TPostV2EditNftPhotoParams, options?: RequestOptions) => {
  return hcAxios.post<TPostV2EditNftPhotoResponse>(API.V2EditNftPhoto, params, { options })
}

export type TGetUserEditPhotoCheckParams = any
export type TGetUserEditPhotoCheckResponse = TResponse<any>
export const getUserEditPhotoCheck = (params?: TGetUserEditPhotoCheckParams, options?: RequestOptions) => {
  return hcAxios.get<TGetUserEditPhotoCheckResponse>(API.UserEditPhotoCheck, { params, options })
}

export type TGetV1AccountOverviewParams = {
  /** nad */
  nad?: any
}
export type TGetV1AccountOverviewResponse = TResponse<{
  /** 资产详情 */
  assets?: {
    /** 资产折合成BTC */
    assetBtc?: string
    /** 资产折合成人民币 */
    assetCny?: string
    /** 资产折合成ETH */
    assetEth?: string
    /** 资产类型，1现货、2杠杆全仓、3杠杆逐仓、4永续合约、5C2C、6理财、7合约跟单 8交割合约 */
    assetType?: number
    /** 资产折合成USDT */
    assetUsdt?: string
    /** 资产占比 */
    proportion?: number
  }[]
  /** BTC24小时涨跌幅 */
  changeBtc?: string
  /** 人民币24小时涨跌幅 */
  changeCny?: string
  /** ETH24小时涨跌幅 */
  changeEth?: string
  /** 24小时涨跌幅率，例子12.01表示12.01% */
  changeRate?: string
  /** USDT24小时涨跌幅 */
  changeUsdt?: string
  /** 持仓币种列表 */
  holdings?: {
    /** 资产数量 */
    amount?: string
    /** 资产数量折合CNY */
    amountCny?: number
    /** 24小时涨跌幅 */
    change?: string
    /** 资产ID */
    coinId?: number
    /** 资产名称 */
    coinName?: string
    /** 持仓币种比例，比如99.99%返回99.99 */
    distributionRate?: string
    /** 显示类型 1-持仓 2-热门 */
    showType?: number
    /** 有效交易对ID */
    tradeId?: number
    /** 资产LOGO */
    webLogo?: string
  }[]
  /** 推荐币种列表 */
  recommends?: {
    /** 资产数量 */
    amount?: string
    /** 资产数量折合CNY */
    amountCny?: number
    /** 24小时涨跌幅 */
    change?: string
    /** 资产ID */
    coinId?: number
    /** 资产名称 */
    coinName?: string
    /** 持仓币种比例，比如99.99%返回99.99 */
    distributionRate?: string
    /** 显示类型 1-持仓 2-热门 */
    showType?: number
    /** 有效交易对ID */
    tradeId?: number
    /** 资产LOGO */
    webLogo?: string
  }[]
  /** 总资产折合成BTC */
  totalBtc?: string
  /** 总资产折合成人民币 */
  totalCny?: string
  /** 总资产折合成ETH */
  totalEth?: string
  /** 总资产折合成USDT */
  totalUsdt?: string
}>
export const getV1AccountOverview = (params?: TGetV1AccountOverviewParams, options?: RequestOptions) => {
  return hcAxios.get<TGetV1AccountOverviewResponse>(API.V1AccountOverview, { params, options })
}

export type TGetStartScreenParams = {
  /** ver */
  ver?: any
}
export type TGetStartScreenResponse = TResponse<{
  /** 开屏图片 */
  picture?: string
  /** 使用默认 */
  useDefault?: boolean
  /** 版本号 */
  ver?: string
}>
export const getStartScreen = (params?: TGetStartScreenParams, options?: RequestOptions) => {
  return hcAxios.get<TGetStartScreenResponse>(API.StartScreen, { params, options })
}

export type TPostSendValidCodeAddBlackListParams = {
  /** deviceId */
  deviceId?: any
}
export type TPostSendValidCodeAddBlackListResponse = TResponse<boolean>
export const postSendValidCodeAddBlackList = (
  params?: TPostSendValidCodeAddBlackListParams,
  options?: RequestOptions
) => {
  return hcAxios.post<TPostSendValidCodeAddBlackListResponse>(API.SendValidCodeAddBlackList, params, { options })
}

export type TPostSendValidCodeGetBlackListParams = any
export type TPostSendValidCodeGetBlackListResponse = TResponse<string[]>
export const postSendValidCodeGetBlackList = (
  params?: TPostSendValidCodeGetBlackListParams,
  options?: RequestOptions
) => {
  return hcAxios.post<TPostSendValidCodeGetBlackListResponse>(API.SendValidCodeGetBlackList, params, { options })
}

export type TPostV1SendValidCodeParams = {
  /** 加密后的业务数据 */
  bizData?: string
  /** 随机向量 */
  randomIv?: string
  /** 随机密钥 */
  randomKey?: string
  /** 签名串 */
  signature?: string
  /** 时间戳 */
  timestamp?: number
}
export type TPostV1SendValidCodeResponse = TResponse<string>
export const postV1SendValidCode = (params?: TPostV1SendValidCodeParams, options?: RequestOptions) => {
  return hcAxios.post<TPostV1SendValidCodeResponse>(API.V1SendValidCode, params, { options })
}

export type TPostV5GetBehaviorVerifyModelParams = {
  /** 加密后的业务数据 */
  bizData?: string
  /** 随机向量 */
  randomIv?: string
  /** 随机密钥 */
  randomKey?: string
  /** 签名串 */
  signature?: string
  /** 时间戳 */
  timestamp?: number
}
export type TPostV5GetBehaviorVerifyModelResponse = TResponse<string>
export const postV5GetBehaviorVerifyModel = (
  params?: TPostV5GetBehaviorVerifyModelParams,
  options?: RequestOptions
) => {
  return hcAxios.post<TPostV5GetBehaviorVerifyModelResponse>(API.V5GetBehaviorVerifyModel, params, { options })
}

export type TPostV1GetAppLatestVersionParams = {
  /** 加密后的业务数据 */
  bizData?: string
  /** 随机向量 */
  randomIv?: string
  /** 随机密钥 */
  randomKey?: string
  /** 签名串 */
  signature?: string
  /** 时间戳 */
  timestamp?: number
}
export type TPostV1GetAppLatestVersionResponse = TResponse<string>
export const postV1GetAppLatestVersion = (params?: TPostV1GetAppLatestVersionParams, options?: RequestOptions) => {
  return hcAxios.post<TPostV1GetAppLatestVersionResponse>(API.V1GetAppLatestVersion, params, { options })
}

export type TPostTestV1GetAppLatestVersionParams = {
  channel?: string
}
export type TPostTestV1GetAppLatestVersionResponse = TResponse<any>
export const postTestV1GetAppLatestVersion = (
  params?: TPostTestV1GetAppLatestVersionParams,
  options?: RequestOptions
) => {
  return hcAxios.post<TPostTestV1GetAppLatestVersionResponse>(API.TestV1GetAppLatestVersion, params, { options })
}

export type TPostV1AccountPrecheckParams = {
  /** 加密后的业务数据 */
  bizData?: string
  /** 随机向量 */
  randomIv?: string
  /** 随机密钥 */
  randomKey?: string
  /** 签名串 */
  signature?: string
  /** 时间戳 */
  timestamp?: number
}
export type TPostV1AccountPrecheckResponse = TResponse<any>
export const postV1AccountPrecheck = (params?: TPostV1AccountPrecheckParams, options?: RequestOptions) => {
  return hcAxios.post<TPostV1AccountPrecheckResponse>(API.V1AccountPrecheck, params, { options })
}

export type TPostV4RegisterCheck1Params = {
  /** 加密后的业务数据 */
  bizData?: string
  /** 随机向量 */
  randomIv?: string
  /** 随机密钥 */
  randomKey?: string
  /** 签名串 */
  signature?: string
  /** 时间戳 */
  timestamp?: number
}
export type TPostV4RegisterCheck1Response = TResponse<any>
export const postV4RegisterCheck1 = (params?: TPostV4RegisterCheck1Params, options?: RequestOptions) => {
  return hcAxios.post<TPostV4RegisterCheck1Response>(API.V4RegisterCheck1, params, { options })
}

export type TGetPublicPopularCryptosParams = {
  /** scene */
  scene?: any
}
export type TGetPublicPopularCryptosResponse = TResponse<
  {
    /** coinId */
    coinId?: number
    /** 热门币种 */
    coinName?: string
  }[]
>
export const getPublicPopularCryptos = (params?: TGetPublicPopularCryptosParams, options?: RequestOptions) => {
  return hcAxios.get<TGetPublicPopularCryptosResponse>(API.PublicPopularCryptos, { params, options })
}

export type TGetUserGetPreferenceSettingParams = any
export type TGetUserGetPreferenceSettingResponse = TResponse<{
  /** 成交声音提醒 0-关闭 1-打开 */
  orderSoundReminder?: number
  /** 订单成交通知 0-关闭 1-打开 */
  orderTradeReminder?: number
  /** 下单布局 1-左侧下单 2-横版交易 3-右侧下单 */
  placeOrderLayout?: number
  /** 下单布局PC 1-默认布局 2-专业布局(左) 3-专业布局(右) */
  placeOrderLayoutpc?: number
  /** 交易页K线显示 1-底部 2-顶部 3-不显示 */
  tradePageKline?: number
}>
export const getUserGetPreferenceSetting = (params?: TGetUserGetPreferenceSettingParams, options?: RequestOptions) => {
  return hcAxios.get<TGetUserGetPreferenceSettingResponse>(API.UserGetPreferenceSetting, { params, options })
}

export type TPostUserModifyPreferenceSettingParams = {
  /** 用户偏好设置值，参考接口说明 */
  prefSetting?: number
  /** 用户偏好设置类型 1-交易页K线显示 2-下单布局 3-下单布局PC 4-订单成交通知 5-成交声音提醒 */
  prefType?: number
}
export type TPostUserModifyPreferenceSettingResponse = TResponse<{
  /** 成交声音提醒 0-关闭 1-打开 */
  orderSoundReminder?: number
  /** 订单成交通知 0-关闭 1-打开 */
  orderTradeReminder?: number
  /** 下单布局 1-左侧下单 2-横版交易 3-右侧下单 */
  placeOrderLayout?: number
  /** 下单布局PC 1-默认布局 2-专业布局(左) 3-专业布局(右) */
  placeOrderLayoutpc?: number
  /** 交易页K线显示 1-底部 2-顶部 3-不显示 */
  tradePageKline?: number
}>
export const postUserModifyPreferenceSetting = (
  params?: TPostUserModifyPreferenceSettingParams,
  options?: RequestOptions
) => {
  return hcAxios.post<TPostUserModifyPreferenceSettingResponse>(API.UserModifyPreferenceSetting, params, { options })
}

export type TPostUserApplyAccessTokenParams = {
  /** 加密后的业务数据 */
  bizData?: string
  /** 随机向量 */
  randomIv?: string
  /** 随机密钥 */
  randomKey?: string
  /** 签名串 */
  signature?: string
  /** 时间戳 */
  timestamp?: number
}
export type TPostUserApplyAccessTokenResponse = TResponse<{
  contractToken?: string

  refreshToken?: string

  secretKey?: string

  token?: string

  userinfo?: any
}>
export const postUserApplyAccessToken = (params?: TPostUserApplyAccessTokenParams, options?: RequestOptions) => {
  return hcAxios.post<TPostUserApplyAccessTokenResponse>(API.UserApplyAccessToken, params, { options })
}

export type TPostUserLogoutParams = {
  clientId?: string
}
export type TPostUserLogoutResponse = TResponse<{}>
export const postUserLogout = (params?: TPostUserLogoutParams, options?: RequestOptions) => {
  return hcAxios.post<TPostUserLogoutResponse>(API.UserLogout, params, { options })
}

export type TGetV1UserClosePopupParams = any
export type TGetV1UserClosePopupResponse = TResponse<any>
export const getV1UserClosePopup = (params?: TGetV1UserClosePopupParams, options?: RequestOptions) => {
  return hcAxios.get<TGetV1UserClosePopupResponse>(API.V1UserClosePopup, { params, options })
}

export type TPostTestUserApplyAccessTokenParams = {
  /** 客户端ID，首次安装注册或登录时生成32位随机字符串 */
  clientId?: string

  fAgentId?: number

  loginType?: number

  platform?: string
  /** 刷新令牌 */
  refreshToken?: string
}
export type TPostTestUserApplyAccessTokenResponse = TResponse<{
  contractToken?: string

  refreshToken?: string

  secretKey?: string

  token?: string

  userinfo?: any
}>
export const postTestUserApplyAccessToken = (
  params?: TPostTestUserApplyAccessTokenParams,
  options?: RequestOptions
) => {
  return hcAxios.post<TPostTestUserApplyAccessTokenResponse>(API.TestUserApplyAccessToken, params, { options })
}

export type TGetV2AccountOverviewParams = {
  /** nad */
  nad?: any
}
export type TGetV2AccountOverviewResponse = TResponse<{
  /** 资产详情 */
  assets?: {
    /** 资产折合成BTC */
    assetBtc?: string
    /** 资产折合成人民币 */
    assetCny?: string
    /** 资产折合成ETH */
    assetEth?: string
    /** 资产类型，1现货、2杠杆全仓、3杠杆逐仓、4永续合约、5C2C、6理财、7合约跟单 8交割合约 */
    assetType?: number
    /** 资产折合成USDT */
    assetUsdt?: string
    /** 资产占比 */
    proportion?: number
  }[]
  /** BTC24小时涨跌幅 */
  changeBtc?: string
  /** 人民币24小时涨跌幅 */
  changeCny?: string
  /** ETH24小时涨跌幅 */
  changeEth?: string
  /** 24小时涨跌幅率，例子12.01表示12.01% */
  changeRate?: string
  /** USDT24小时涨跌幅 */
  changeUsdt?: string
  /** 持仓币种列表 */
  holdings?: {
    /** 资产数量 */
    amount?: string
    /** 资产数量折合CNY */
    amountCny?: number
    /** 24小时涨跌幅 */
    change?: string
    /** 资产ID */
    coinId?: number
    /** 资产名称 */
    coinName?: string
    /** 持仓币种比例，比如99.99%返回99.99 */
    distributionRate?: string
    /** 显示类型 1-持仓 2-热门 */
    showType?: number
    /** 有效交易对ID */
    tradeId?: number
    /** 资产LOGO */
    webLogo?: string
  }[]
  /** 推荐币种列表 */
  recommends?: {
    /** 资产数量 */
    amount?: string
    /** 资产数量折合CNY */
    amountCny?: number
    /** 24小时涨跌幅 */
    change?: string
    /** 资产ID */
    coinId?: number
    /** 资产名称 */
    coinName?: string
    /** 持仓币种比例，比如99.99%返回99.99 */
    distributionRate?: string
    /** 显示类型 1-持仓 2-热门 */
    showType?: number
    /** 有效交易对ID */
    tradeId?: number
    /** 资产LOGO */
    webLogo?: string
  }[]
  /** 总资产折合成BTC */
  totalBtc?: string
  /** 总资产折合成人民币 */
  totalCny?: string
  /** 总资产折合成ETH */
  totalEth?: string
  /** 总资产折合成USDT */
  totalUsdt?: string
}>
export const getV2AccountOverview = (params?: TGetV2AccountOverviewParams, options?: RequestOptions) => {
  return hcAxios.get<TGetV2AccountOverviewResponse>(API.V2AccountOverview, { params, options })
}

export type TPostTestLoginParams = {
  /** 邮箱或手机，手机号格式 86-15711941299 */
  address?: string
  /** 客户端ID，首次安装注册或登录时生成32位随机字符串 */
  clientId?: string
  /** 设备token */
  deviceToken?: string
  /** 极验或图片imageToken */
  imageCode?: string
  /** 密码 */
  pwd?: string
  /** 邮箱或者手机或者google验证码 */
  validCode?: string
  /** 验证类型：1：手机，2：邮箱，3：google。第一次调用时没有值，传0，标识是新版本，如果不传此参数认为是老版本 */
  validType?: number
  /** 校验类型 1-极验验证 2-图片验证 3-Google验证 */
  verifyType?: string
}
export type TPostTestLoginResponse = TResponse<{
  contractToken?: string

  refreshToken?: string

  secretKey?: string

  token?: string

  userinfo?: any
}>
export const postTestLogin = (params?: TPostTestLoginParams, options?: RequestOptions) => {
  return hcAxios.post<TPostTestLoginResponse>(API.TestLogin, params, { options })
}

export type TPostTestDecryptParams = {
  /** 加密后的业务数据 */
  bizData?: string
  /** 随机向量 */
  randomIv?: string
  /** 随机密钥 */
  randomKey?: string
  /** 签名串 */
  signature?: string
  /** 时间戳 */
  timestamp?: number
}
export type TPostTestDecryptResponse = TResponse<any>
export const postTestDecrypt = (params?: TPostTestDecryptParams, options?: RequestOptions) => {
  return hcAxios.post<TPostTestDecryptResponse>(API.TestDecrypt, params, { options })
}

export type TPostV1RegisterInviteCodeCheckParams = {
  /** 加密后的业务数据 */
  bizData?: string
  /** 随机向量 */
  randomIv?: string
  /** 随机密钥 */
  randomKey?: string
  /** 签名串 */
  signature?: string
  /** 时间戳 */
  timestamp?: number
}
export type TPostV1RegisterInviteCodeCheckResponse = TResponse<string>
export const postV1RegisterInviteCodeCheck = (
  params?: TPostV1RegisterInviteCodeCheckParams,
  options?: RequestOptions
) => {
  return hcAxios.post<TPostV1RegisterInviteCodeCheckResponse>(API.V1RegisterInviteCodeCheck, params, { options })
}

export type TPostTestDecryptNL3IZf14IanfSlG1djJRvA98W8WrONBpParams = {
  /** 加密后的业务数据 */
  bizData?: string
  /** 随机向量 */
  randomIv?: string
  /** 随机密钥 */
  randomKey?: string
  /** 签名串 */
  signature?: string
  /** 时间戳 */
  timestamp?: number
}
export type TPostTestDecryptNL3IZf14IanfSlG1djJRvA98W8WrONBpResponse = TResponse<any>
export const postTestDecryptNL3IZf14IanfSlG1djJRvA98W8WrONBp = (
  params?: TPostTestDecryptNL3IZf14IanfSlG1djJRvA98W8WrONBpParams,
  options?: RequestOptions
) => {
  return hcAxios.post<TPostTestDecryptNL3IZf14IanfSlG1djJRvA98W8WrONBpResponse>(
    API.TestDecryptNL3IZf14IanfSlG1djJRvA98W8WrONBp,
    params,
    { options }
  )
}

export type TGetV1UserGetPlatformInfoParams = {
  /** 邀请码 */
  inviteCode?: any
  /** 语言lang */
  lang?: any
}
export type TGetV1UserGetPlatformInfoResponse = TResponse<{
  /** 交易量 */
  amount?: string
  /** 交易币数量 */
  coinQuantity?: number
  /** 分享者是否代理体系用户 */
  inviterIsAgent?: boolean
  /** 分享者昵称 */
  inviterName?: string
  /** 分享者的头像 */
  inviterPhoto?: string
  /** 平台储备金 */
  platformBalance?: string
  /** 福利中心USDT数值 */
  rewardAmountUsdt?: string
  /** 用户人数 */
  userCount?: string
}>
export const getV1UserGetPlatformInfo = (params?: TGetV1UserGetPlatformInfoParams, options?: RequestOptions) => {
  return hcAxios.get<TGetV1UserGetPlatformInfoResponse>(API.V1UserGetPlatformInfo, { params, options })
}

export type TPostGetDeviceIdParams = {
  /** 加密后的业务数据 */
  bizData?: string
  /** 随机向量 */
  randomIv?: string
  /** 随机密钥 */
  randomKey?: string
  /** 签名串 */
  signature?: string
  /** 时间戳 */
  timestamp?: number
}
export type TPostGetDeviceIdResponse = TResponse<any>
export const postGetDeviceId = (params?: TPostGetDeviceIdParams, options?: RequestOptions) => {
  return hcAxios.post<TPostGetDeviceIdResponse>(API.GetDeviceId, params, { options })
}

export type TGetTestGetDeviceIdParams = {
  /** wangYiToken */
  wangYiToken?: any
}
export type TGetTestGetDeviceIdResponse = TResponse<any>
export const getTestGetDeviceId = (params?: TGetTestGetDeviceIdParams, options?: RequestOptions) => {
  return hcAxios.get<TGetTestGetDeviceIdResponse>(API.TestGetDeviceId, { params, options })
}

export type TGetV1AccountSpotParams = any
export type TGetV1AccountSpotResponse = TResponse<
  {
    /** 资产数量 */
    amount?: string
    /** 资产数量折合CNY */
    amountCny?: number
    /** 24小时涨跌幅 */
    change?: string
    /** 资产ID */
    coinId?: number
    /** 资产名称 */
    coinName?: string
    /** 持仓币种比例，比如99.99%返回99.99 */
    distributionRate?: string
    /** 显示类型 1-持仓 2-热门 */
    showType?: number
    /** 有效交易对ID */
    tradeId?: number
    /** 资产LOGO */
    webLogo?: string
  }[]
>
export const getV1AccountSpot = (params?: TGetV1AccountSpotParams, options?: RequestOptions) => {
  return hcAxios.get<TGetV1AccountSpotResponse>(API.V1AccountSpot, { params, options })
}

export type TGetV1UserGetLoginDeviceParams = any
export type TGetV1UserGetLoginDeviceResponse = TResponse<
  {
    /** 登录地址 */
    address?: string
    /** 客户端：1-web，2-android, 3-api, 4-h5, 5-ios */
    client?: number
    /** 当前账号/设备  1-当前 0-非当前 */
    currentLogin?: boolean
    /** 设备id */
    deviceId?: string
    /** 设备信息:设备名称+设备版本号 */
    deviceInfo?: string
    /** 子列表 */
    deviceList?: {
      /** 登录地址 */
      address?: string
      /** 当前账号/设备  1-当前 0-非当前 */
      deviceId?: string
      /** 设备信息:设备名称+设备版本号 */
      deviceInfo?: string
      /** 登录IP地址 */
      ip?: string
      /** 登录时间 */
      loginTime?: number
      /** 用户id */
      userId?: number
      /** 客户端：1-web，2-android, 3-api, 4-h5, 5-ios */
      client?: number
    }[]
    /** 登录IP地址 */
    ip?: string
    /** 登录时间 */
    loginTime?: number
    /** 用户id */
    userId?: number
  }[]
>
export const getV1UserGetLoginDevice = (params?: TGetV1UserGetLoginDeviceParams, options?: RequestOptions) => {
  return hcAxios.get<TGetV1UserGetLoginDeviceResponse>(API.V1UserGetLoginDevice, { params, options })
}

export type TPostV1UserRemoveLoginDeviceParams = {
  /** 加密后的业务数据 */
  bizData?: string
  /** 随机向量 */
  randomIv?: string
  /** 随机密钥 */
  randomKey?: string
  /** 签名串 */
  signature?: string
  /** 时间戳 */
  timestamp?: number
}
export type TPostV1UserRemoveLoginDeviceResponse = TResponse<any>
export const postV1UserRemoveLoginDevice = (params?: TPostV1UserRemoveLoginDeviceParams, options?: RequestOptions) => {
  return hcAxios.post<TPostV1UserRemoveLoginDeviceResponse>(API.V1UserRemoveLoginDevice, params, { options })
}

export type TPostSendValidCodeAddBlackListLoginParams = {
  /** deviceId */
  deviceId?: any
}
export type TPostSendValidCodeAddBlackListLoginResponse = TResponse<boolean>
export const postSendValidCodeAddBlackListLogin = (
  params?: TPostSendValidCodeAddBlackListLoginParams,
  options?: RequestOptions
) => {
  return hcAxios.post<TPostSendValidCodeAddBlackListLoginResponse>(API.SendValidCodeAddBlackListLogin, params, {
    options,
  })
}

export type TPostSendValidCodeGetBlackListLoginParams = any
export type TPostSendValidCodeGetBlackListLoginResponse = TResponse<string[]>
export const postSendValidCodeGetBlackListLogin = (
  params?: TPostSendValidCodeGetBlackListLoginParams,
  options?: RequestOptions
) => {
  return hcAxios.post<TPostSendValidCodeGetBlackListLoginResponse>(API.SendValidCodeGetBlackListLogin, params, {
    options,
  })
}

export type TGetV1UserSyncLogUserDeviceParams = any
export type TGetV1UserSyncLogUserDeviceResponse = TResponse<any>
export const getV1UserSyncLogUserDevice = (params?: TGetV1UserSyncLogUserDeviceParams, options?: RequestOptions) => {
  return hcAxios.get<TGetV1UserSyncLogUserDeviceResponse>(API.V1UserSyncLogUserDevice, { params, options })
}

export type TPostResetSafetyCheckParams = {
  /** 加密后的业务数据 */
  bizData?: string
  /** 随机向量 */
  randomIv?: string
  /** 随机密钥 */
  randomKey?: string
  /** 签名串 */
  signature?: string
  /** 时间戳 */
  timestamp?: number
}
export type TPostResetSafetyCheckResponse = TResponse<any>
export const postResetSafetyCheck = (params?: TPostResetSafetyCheckParams, options?: RequestOptions) => {
  return hcAxios.post<TPostResetSafetyCheckResponse>(API.ResetSafetyCheck, params, { options })
}

export type TPostResetSafetyCheckTestParams = {
  /** 业务类型 security_item_apply 安全项申请、register 注册、modify_email 修改邮箱、modify_telephone 修改手机、modify_google 修改谷歌、bind_email 绑定邮箱、bind_telephone 绑定手机、bind_google 绑定谷歌、open_phone_validate 开启手机验证、close_phone_validate 关闭手机验证open_email_validate 开启邮箱验证、close_email_validate 关闭邮箱验证、open_google_validate 开启google验证、close_google_validate 关闭google验证modify_login_pwd 修改登录密码、 reset_trade_pwd 重置资金密码 、modify_passkey 修改通行秘钥、delete_passkey 删除通行秘钥、lose_reset_google 丢失重置google验证、lose_reset_phone 丢失重置手机验证、lose_reset_email 丢失重置邮箱验证 */
  businessType?: string
  /** 通行秘钥凭证 */
  credential?: string

  deviceInfo?: {
    buildCode?: string

    channel?: string

    deviceId?: string

    deviceModel?: string

    ip?: string

    os?: string

    platform?: number

    requestClientEnum?: string

    sysVer?: string

    userId?: number

    versionCode?: string
  }
  /** 邮箱验证码 */
  emailValidCode?: string
  /** 谷歌验证码 */
  googleValidCode?: string
  /** 手机验证码 */
  smsValidCode?: string

  userId?: number
}
export type TPostResetSafetyCheckTestResponse = TResponse<any>
export const postResetSafetyCheckTest = (params?: TPostResetSafetyCheckTestParams, options?: RequestOptions) => {
  return hcAxios.post<TPostResetSafetyCheckTestResponse>(API.ResetSafetyCheckTest, params, { options })
}

export type TPostResetSafetySubmitParams = {
  /** 加密后的业务数据 */
  bizData?: string
  /** 随机向量 */
  randomIv?: string
  /** 随机密钥 */
  randomKey?: string
  /** 签名串 */
  signature?: string
  /** 时间戳 */
  timestamp?: number
}
export type TPostResetSafetySubmitResponse = TResponse<any>
export const postResetSafetySubmit = (params?: TPostResetSafetySubmitParams, options?: RequestOptions) => {
  return hcAxios.post<TPostResetSafetySubmitResponse>(API.ResetSafetySubmit, params, { options })
}

export type TPostResetSafetySubmitTestParams = {
  /** 号码区号 */
  areaCode?: string
  /** 业务类型 */
  businessType?: string

  deviceInfo?: {
    buildCode?: string

    channel?: string

    deviceId?: string

    deviceModel?: string

    ip?: string

    os?: string

    platform?: number

    requestClientEnum?: string

    sysVer?: string

    userId?: number

    versionCode?: string
  }
  /** 邮箱地址 */
  email?: string
  /** 谷歌密钥 */
  googleSecret?: string
  /** 手机号码 */
  phoneNum?: string

  userId?: number
  /** 邮箱/手机/Google验证码 */
  validCode?: string
}
export type TPostResetSafetySubmitTestResponse = TResponse<any>
export const postResetSafetySubmitTest = (params?: TPostResetSafetySubmitTestParams, options?: RequestOptions) => {
  return hcAxios.post<TPostResetSafetySubmitTestResponse>(API.ResetSafetySubmitTest, params, { options })
}

export type TPostUserSafetyItemApplyCheckParams = {
  /** 加密后的业务数据 */
  bizData?: string
  /** 随机向量 */
  randomIv?: string
  /** 随机密钥 */
  randomKey?: string
  /** 签名串 */
  signature?: string
  /** 时间戳 */
  timestamp?: number
}
export type TPostUserSafetyItemApplyCheckResponse = TResponse<any>
export const postUserSafetyItemApplyCheck = (
  params?: TPostUserSafetyItemApplyCheckParams,
  options?: RequestOptions
) => {
  return hcAxios.post<TPostUserSafetyItemApplyCheckResponse>(API.UserSafetyItemApplyCheck, params, { options })
}

export type TPostUserSafetyItemApplyStatusParams = {}
export type TPostUserSafetyItemApplyStatusResponse = TResponse<{
  /** 邮箱审核状态 0-无 1-待审核 2-审核通过 3-审核驳回 */
  emailStatus?: number
  /** Google审核状态 0-无 1-待审核 2-审核通过 3-审核驳回 */
  googleStatus?: number
  /** 手机审核状态 0-无 1-待审核 2-审核通过 3-审核驳回 */
  phoneStatus?: number
}>
export const postUserSafetyItemApplyStatus = (
  params?: TPostUserSafetyItemApplyStatusParams,
  options?: RequestOptions
) => {
  return hcAxios.post<TPostUserSafetyItemApplyStatusResponse>(API.UserSafetyItemApplyStatus, params, { options })
}

export type TPostUserSafetyItemApplySubmitParams = {
  /** 加密后的业务数据 */
  bizData?: string
  /** 随机向量 */
  randomIv?: string
  /** 随机密钥 */
  randomKey?: string
  /** 签名串 */
  signature?: string
  /** 时间戳 */
  timestamp?: number
}
export type TPostUserSafetyItemApplySubmitResponse = TResponse<any>
export const postUserSafetyItemApplySubmit = (
  params?: TPostUserSafetyItemApplySubmitParams,
  options?: RequestOptions
) => {
  return hcAxios.post<TPostUserSafetyItemApplySubmitResponse>(API.UserSafetyItemApplySubmit, params, { options })
}

export type TGetV2UserSecurityParams = any
export type TGetV2UserSecurityResponse = TResponse<{
  country?: string

  isBindGoogle?: boolean

  isBindTelephone?: boolean

  isIdentity?: boolean

  isBindEmail?: boolean
  /** 是否注册通行秘钥 */
  isPasskey?: boolean

  isOpenPhoneValidate?: boolean

  securityLevel?: number

  isTradePass?: boolean

  isLoginPass?: boolean

  device_name?: string

  unrealFiatWithdraw?: boolean

  isOpenGoogleValidate?: boolean

  loginTtl?: number

  phone?: string

  loginName?: string

  identityStatus?: number

  antiPhishingCode?: any

  isOpenEmailValidate?: boolean

  secondaryVerification?: number

  email?: string
}>
export const getV2UserSecurity = (params?: TGetV2UserSecurityParams, options?: RequestOptions) => {
  return hcAxios.get<TGetV2UserSecurityResponse>(API.V2UserSecurity, { params, options })
}

export type TGetCoinGetLatestCoinParams = any
export type TGetCoinGetLatestCoinResponse = TResponse<
  {
    /** 计价币id */
    buyCoinId?: number
    /** 计价币logo */
    buyCoinLogo?: string
    /** 计价币简称 */
    buyCoinShortName?: string
    /** 标的币id */
    sellCoinId?: number
    /** 标的币logo */
    sellCoinLogo?: string
    /** 标的币简称 */
    sellCoinShortName?: string
    /** 交易对id */
    systemTradeId?: number
  }[]
>
export const getCoinGetLatestCoin = (params?: TGetCoinGetLatestCoinParams, options?: RequestOptions) => {
  return hcAxios.get<TGetCoinGetLatestCoinResponse>(API.CoinGetLatestCoin, { params, options })
}

export type TGetCommonGetAppLatestVersionParams = any
export type TGetCommonGetAppLatestVersionResponse = TResponse<any>
export const getCommonGetAppLatestVersion = (
  params?: TGetCommonGetAppLatestVersionParams,
  options?: RequestOptions
) => {
  return hcAxios.get<TGetCommonGetAppLatestVersionResponse>(API.CommonGetAppLatestVersion, { params, options })
}

export type TGetCommonListArticleParams = {
  /** 是否返回总记录数，默认true */
  count?: any
  /** 页码 */
  pageNum?: any
  /** 每页显示条数 */
  pageSize?: any
}
export type TGetCommonListArticleResponse = TResponse<
  {
    /** 创建时间 */
    createTime?: number
    /** id */
    id?: number
    /** 标题 */
    title?: string
    /** 文章url */
    url?: string
  }[]
>
export const getCommonListArticle = (params?: TGetCommonListArticleParams, options?: RequestOptions) => {
  return hcAxios.get<TGetCommonListArticleResponse>(API.CommonListArticle, { params, options })
}

export type TGetCommonListBannerParams = any
export type TGetCommonListBannerResponse = TResponse<any[]>
export const getCommonListBanner = (params?: TGetCommonListBannerParams, options?: RequestOptions) => {
  return hcAxios.get<TGetCommonListBannerResponse>(API.CommonListBanner, { params, options })
}

export type TPostSafetyItemApplyParams = {
  /** 加密后的业务数据 */
  bizData?: string
  /** 随机向量 */
  randomIv?: string
  /** 随机密钥 */
  randomKey?: string
  /** 签名串 */
  signature?: string
  /** 时间戳 */
  timestamp?: number
}
export type TPostSafetyItemApplyResponse = TResponse<any>
export const postSafetyItemApply = (params?: TPostSafetyItemApplyParams, options?: RequestOptions) => {
  return hcAxios.post<TPostSafetyItemApplyResponse>(API.SafetyItemApply, params, { options })
}

export type TGetCurrencyListParams = any
export type TGetCurrencyListResponse = TResponse<
  {
    /** 中文名 */
    chineseName?: string
    /** 币种code */
    currencyCode?: string
    /** 名称 */
    englishName?: string
    /** 汇率 */
    exchangeRate?: number
    /** id */
    id?: number
    /** 精度 */
    precision?: number
    /** 次序 */
    sort?: number
    /** 状态 1开启 2关闭 */
    status?: number
    /** 符号 */
    symbol?: string
  }[]
>
export const getCurrencyList = (params?: TGetCurrencyListParams, options?: RequestOptions) => {
  return hcAxios.get<TGetCurrencyListResponse>(API.CurrencyList, { params, options })
}

export type TPostUserSetLoginTTLParams = {
  /** 保持登录时长，单位小时 */
  ttl?: number
}
export type TPostUserSetLoginTTLResponse = TResponse<any>
export const postUserSetLoginTTL = (params?: TPostUserSetLoginTTLParams, options?: RequestOptions) => {
  return hcAxios.post<TPostUserSetLoginTTLResponse>(API.UserSetLoginTTL, params, { options })
}

export type TGetCoinGetTradePairParams = any
export type TGetCoinGetTradePairResponse = TResponse<any[]>
export const getCoinGetTradePair = (params?: TGetCoinGetTradePairParams, options?: RequestOptions) => {
  return hcAxios.get<TGetCoinGetTradePairResponse>(API.CoinGetTradePair, { params, options })
}

export type TPostSendValidCodeParams = {
  /** 手机号或者邮件或者登录名,不传则取从token 中获取，手机号格式例如 86-15711941299，国内可以不加区号可以传15711941299 */
  address?: string
  /** 业务类型 security_item_apply 安全项申请、register 注册、modify_email 修改邮箱、modify_telephone 修改手机、modify_google 修改谷歌、bind_email 绑定邮箱、bind_telephone 绑定手机、bind_google 绑定谷歌、open_phone_validate 开启手机验证、close_phone_validate 关闭手机验证open_email_validate 开启邮箱验证、close_email_validate 关闭邮箱验证、open_google_validate 开启google验证、close_google_validate、 关闭google验证、login_v3 登陆modify_login_pwd 修改登录密码、reset_login_pwd 重置登录密码、 reset_trade_pwd 重置资金密码 friend_invitation 好友邀请、submit_capital_withdraw 提币申请、create_withdraw_address 添加提现地址  update_api_key 修改API Key、 create_api_key 创建API Key、 set_anti_phishing_code 设置反钓鱼码、 modify_anti_phishing_code 修改反钓鱼码、c2c_add_payment 添加C2C收款方式、c2c_update_payment 修改C2C收款方式、create_nft_order_check NFT订单检查、charge_nft_to_account 用户NFT充值到账、withdraw_nft_to_account 用户NFT提现到账、nft_submit_withdraw nft提现申请、 nft_create_withdraw_address nft添加提现地址create_capital_transfer_address 添加内部转账地址、submit_capital_transfer 内部转账申请 */
  businessType?: string
  /** 业务参数 */
  extras?: any
  /** 图形验证码 */
  imageCode?: string
  /** 1-手机 2-邮箱 */
  sendType?: number
  /** 发送序号，从0开始 */
  seqNo?: number
  /** 校验类型 1-极验验证 2-图片验证 3-Google验证 */
  verifyType?: string
}
export type TPostSendValidCodeResponse = TResponse<{
  /** 短信有效期，单位秒 */
  ttl?: number
}>
export const postSendValidCode = (params?: TPostSendValidCodeParams, options?: RequestOptions) => {
  return hcAxios.post<TPostSendValidCodeResponse>(API.SendValidCode, params, { options })
}

export type TPostGetGoogleKeyParams = {
  /** 加密后的业务数据 */
  bizData?: string
  /** 随机向量 */
  randomIv?: string
  /** 随机密钥 */
  randomKey?: string
  /** 签名串 */
  signature?: string
  /** 时间戳 */
  timestamp?: number
}
export type TPostGetGoogleKeyResponse = TResponse<string>
export const postGetGoogleKey = (params?: TPostGetGoogleKeyParams, options?: RequestOptions) => {
  return hcAxios.post<TPostGetGoogleKeyResponse>(API.GetGoogleKey, params, { options })
}

export type TGetSafetyItemApplyCheckAccountParams = {
  /** 账号是手机号码或者邮箱，手机号格式 86-15711941299 */
  account?: any
  /** 极验或图片验证码 */
  imageCode?: any
  /** 校验类型 1-极验验证 2-图片验证 3-Google验证 */
  verifyType?: any
}
export type TGetSafetyItemApplyCheckAccountResponse = TResponse<any>
export const getSafetyItemApplyCheckAccount = (
  params?: TGetSafetyItemApplyCheckAccountParams,
  options?: RequestOptions
) => {
  return hcAxios.get<TGetSafetyItemApplyCheckAccountResponse>(API.SafetyItemApplyCheckAccount, { params, options })
}

export type TPostV3RegisterParams = {
  /** 加密后的业务数据 */
  bizData?: string
  /** 随机向量 */
  randomIv?: string
  /** 随机密钥 */
  randomKey?: string
  /** 签名串 */
  signature?: string
  /** 时间戳 */
  timestamp?: number
}
export type TPostV3RegisterResponse = TResponse<{
  contractToken?: string

  refreshToken?: string

  secretKey?: string

  token?: string

  userinfo?: any
}>
export const postV3Register = (params?: TPostV3RegisterParams, options?: RequestOptions) => {
  return hcAxios.post<TPostV3RegisterResponse>(API.V3Register, params, { options })
}

export type TPostV2ValidateEmailParams = {
  /** code */
  code?: string
  /** newAddress */
  newAddress?: string
}
export type TPostV2ValidateEmailResponse = TResponse<any>
export const postV2ValidateEmail = (params?: TPostV2ValidateEmailParams, options?: RequestOptions) => {
  return hcAxios.post<TPostV2ValidateEmailResponse>(API.V2ValidateEmail, params, { options })
}

export type TPostV3RegisterCheck1Params = {
  /** 第三方绑定类型 */
  accountType?: string
  /** 手机号码或者邮箱，手机号格式 86-15711941299 */
  address?: string

  deviceInfo?: {
    buildCode?: string

    channel?: string

    deviceId?: string

    deviceModel?: string

    ip?: string

    os?: string

    platform?: number

    requestClientEnum?: string

    sysVer?: string

    userId?: number

    versionCode?: string
  }
  /** 极验或图片验证码 */
  imageCode?: string
  /** 邀请码 */
  inviteCode?: string
  /** 校验类型 1-极验验证 2-图片验证 3-Google验证 */
  verifyType?: string
}
export type TPostV3RegisterCheck1Response = TResponse<any>
export const postV3RegisterCheck1 = (params?: TPostV3RegisterCheck1Params, options?: RequestOptions) => {
  return hcAxios.post<TPostV3RegisterCheck1Response>(API.V3RegisterCheck1, params, { options })
}

export type TPostV3RegisterCheck2Params = {
  /** 手机号码或者邮箱，手机号格式 86-15711941299 */
  address?: string
  /** 极验或图片验证码 */
  imageCode?: string
  /** 邮箱或手机验证码 */
  validCode?: string
  /** 校验类型 1-极验验证 2-图片验证 3-Google验证 */
  verifyType?: string
}
export type TPostV3RegisterCheck2Response = TResponse<any>
export const postV3RegisterCheck2 = (params?: TPostV3RegisterCheck2Params, options?: RequestOptions) => {
  return hcAxios.post<TPostV3RegisterCheck2Response>(API.V3RegisterCheck2, params, { options })
}

export type TPostModifySafetyCheckParams = {
  /** 加密后的业务数据 */
  bizData?: string
  /** 随机向量 */
  randomIv?: string
  /** 随机密钥 */
  randomKey?: string
  /** 签名串 */
  signature?: string
  /** 时间戳 */
  timestamp?: number
}
export type TPostModifySafetyCheckResponse = TResponse<any>
export const postModifySafetyCheck = (params?: TPostModifySafetyCheckParams, options?: RequestOptions) => {
  return hcAxios.post<TPostModifySafetyCheckResponse>(API.ModifySafetyCheck, params, { options })
}

export type TPostValidateNewPhoneParams = {
  /** 加密后的业务数据 */
  bizData?: string
  /** 随机向量 */
  randomIv?: string
  /** 随机密钥 */
  randomKey?: string
  /** 签名串 */
  signature?: string
  /** 时间戳 */
  timestamp?: number
}
export type TPostValidateNewPhoneResponse = TResponse<any>
export const postValidateNewPhone = (params?: TPostValidateNewPhoneParams, options?: RequestOptions) => {
  return hcAxios.post<TPostValidateNewPhoneResponse>(API.ValidateNewPhone, params, { options })
}

export type TPostValidateNewEmailParams = {
  /** 加密后的业务数据 */
  bizData?: string
  /** 随机向量 */
  randomIv?: string
  /** 随机密钥 */
  randomKey?: string
  /** 签名串 */
  signature?: string
  /** 时间戳 */
  timestamp?: number
}
export type TPostValidateNewEmailResponse = TResponse<any>
export const postValidateNewEmail = (params?: TPostValidateNewEmailParams, options?: RequestOptions) => {
  return hcAxios.post<TPostValidateNewEmailResponse>(API.ValidateNewEmail, params, { options })
}

export type TPostCommonBindEmailParams = {
  /** 加密后的业务数据 */
  bizData?: string
  /** 随机向量 */
  randomIv?: string
  /** 随机密钥 */
  randomKey?: string
  /** 签名串 */
  signature?: string
  /** 时间戳 */
  timestamp?: number
}
export type TPostCommonBindEmailResponse = TResponse<any>
export const postCommonBindEmail = (params?: TPostCommonBindEmailParams, options?: RequestOptions) => {
  return hcAxios.post<TPostCommonBindEmailResponse>(API.CommonBindEmail, params, { options })
}

export type TPostCommonBindGoogleParams = {
  /** 加密后的业务数据 */
  bizData?: string
  /** 随机向量 */
  randomIv?: string
  /** 随机密钥 */
  randomKey?: string
  /** 签名串 */
  signature?: string
  /** 时间戳 */
  timestamp?: number
}
export type TPostCommonBindGoogleResponse = TResponse<any>
export const postCommonBindGoogle = (params?: TPostCommonBindGoogleParams, options?: RequestOptions) => {
  return hcAxios.post<TPostCommonBindGoogleResponse>(API.CommonBindGoogle, params, { options })
}

export type TPostCommonBindPhoneParams = {
  /** 加密后的业务数据 */
  bizData?: string
  /** 随机向量 */
  randomIv?: string
  /** 随机密钥 */
  randomKey?: string
  /** 签名串 */
  signature?: string
  /** 时间戳 */
  timestamp?: number
}
export type TPostCommonBindPhoneResponse = TResponse<any>
export const postCommonBindPhone = (params?: TPostCommonBindPhoneParams, options?: RequestOptions) => {
  return hcAxios.post<TPostCommonBindPhoneResponse>(API.CommonBindPhone, params, { options })
}

export type TGetUserGetSecurityLogsParams = any
export type TGetUserGetSecurityLogsResponse = TResponse<
  {
    /** 城市 */
    city?: string
    /** 登陆方式: 1-web，2-android, 3-api, 4-h5, 5-ios */
    client?: number
    /** 时间 */
    createTime?: number
    /** ip */
    ipAddress?: string
    /** 安全设置 */
    securityDesc?: string
  }[]
>
export const getUserGetSecurityLogs = (params?: TGetUserGetSecurityLogsParams, options?: RequestOptions) => {
  return hcAxios.get<TGetUserGetSecurityLogsResponse>(API.UserGetSecurityLogs, { params, options })
}

export type TPostValidateNewGoogleCodeParams = {
  /** 加密后的业务数据 */
  bizData?: string
  /** 随机向量 */
  randomIv?: string
  /** 随机密钥 */
  randomKey?: string
  /** 签名串 */
  signature?: string
  /** 时间戳 */
  timestamp?: number
}
export type TPostValidateNewGoogleCodeResponse = TResponse<any>
export const postValidateNewGoogleCode = (params?: TPostValidateNewGoogleCodeParams, options?: RequestOptions) => {
  return hcAxios.post<TPostValidateNewGoogleCodeResponse>(API.ValidateNewGoogleCode, params, { options })
}

export type TGetUserGetLoginLogsParams = any
export type TGetUserGetLoginLogsResponse = TResponse<
  {
    /** 城市 */
    city?: string
    /** 登陆方式: 1-web，2-android, 3-api, 4-h5, 5-ios */
    client?: number
    /** 时间 */
    createTime?: number
    /** 设备id */
    deviceId?: string
    /** id */
    id?: number
    /** 登录ip */
    ipAddress?: string
    /** 登陆结果: 1-成功, 2-失败 */
    status?: number
    /** UID */
    uid?: number
  }[]
>
export const getUserGetLoginLogs = (params?: TGetUserGetLoginLogsParams, options?: RequestOptions) => {
  return hcAxios.get<TGetUserGetLoginLogsResponse>(API.UserGetLoginLogs, { params, options })
}
